// extracted by mini-css-extract-plugin
export default {"inputWrapper":"FormPopup_inputWrapper__IPF7v","singleLineMultiInputs":"FormPopup_singleLineMultiInputs__lTkuP","multiInputsColumn":"FormPopup_multiInputsColumn__RFbkf"};